/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { timeerOffModal } from '/client/src/constants/';
import { PUT, POST } from '/client/src/api';
import DropCropeZone from '/client/src/pages/Events/detail/selfCheckinRoot/DropCropeZone';
import CssPinner from '/client/src/components/csspinner';

import './styles.scss';
import { GetErrorValidation } from '../../../utils/errorMessageValidation';

type PropsType = {
  isOpen: boolean,
  handleToggleModal: (boolean) => void,
  data: any,
  getOrgData: () => void
};

class EditOrgModal extends React.Component<PropsType> {
  props: PropsType;

  static contextType = DefaultContainerContext;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      companyName: props.data.company_name || '',
      supportEmail: props.data.contact_email || '',
      website: props.data.website || '',
      billRemark: props.data.bill_remark || '',
      code_501_c3: props.data.code_501_c3 || '',
      taxLabel: props.data.tax_label || '',
      isLocked: false,
      openedCropModal: false,
      imgUrl: props.data.logo_url,
      baseImage: {
        file: null,
        image: props.data.logo_url
      },
      croppedImage: {
        file: null,
        image: null
      },
      logo_crop_info: props.data.logo_crop_info || { x1: '0', x2: '0', y1: '0', y2: '0' }
    };
  }

  handleClose = (): any => {
    const { handleToggleModal } = this.props;

    handleToggleModal(false);
  };

  handleChangeInput = (e: SyntheticEvent<HTMLInputElement>) => {
    const name = e.target.id;
    const value = e.target.value;

    this.setState({
      [name]: value
    });
  };

  setOpenedCropModal = (status: boolean) => {
    this.setState({
      openedCropModal: status
    });
  }

  setBaseImage = (data: {}) => {
    this.setState({
     baseImage : {
        file: data.file,
        image: data.image
      }
    });
  }

  setCroppedImage = async (data: {}) => {
    await this.handleSaveImg(data.file, (fileURL: string, fileURLrelative: string) => {
      this.setState({
        imgUrl: fileURLrelative
      });
    });
  };

  handleSetImages = (name: string, file: any) => {
    this.setState({
      [name]: file
    });
  }

  handleImageCropInfo = (logo_crop_info: any) => {
    this.setState({
      logo_crop_info
    });
  }

  handleSaveImg = async (file: any, callback: (string, string) => void): any => {
    if (file) {
      const formData = new FormData();

      formData.append('FileName', file);

      try {
        CssPinner(document.querySelector('.EditOrgModal'), true);
        const profileId = this.context.profileCurrent.id;
        const { result } = await POST(
          `/api/v1/1/assets/upload/${profileId}`,
          formData,
          null,
          'multipart/form-data');

        CssPinner(document.querySelector('.EditOrgModal'), false);

        return callback(
          _.get(result, '[0].url', null),
          `${process.env.IMAGE_CASH_URL}/${_.get(result, '[0].relative_url', null)}`
        );
      } catch (error) {
        CssPinner(document.querySelector('.EditOrgModal'), false);
        console.error(error);
      }
    }
  };

  handleSave = async (setStatus: (string) => void) => {
    const {
      companyName,
      supportEmail,
      website,
      billRemark,
      code_501_c3,
      taxLabel,
      croppedImage,
      isLocked,
      imgUrl,
      logo_crop_info
    } = this.state;

    if (isLocked) {
      return;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });
    const data = {
    bill_remark: billRemark,
    code_501_c3,
    company_name: companyName,
    contact_email: supportEmail,
    logo_crop_info,
    logo_url: imgUrl,
    tax_label: taxLabel,
    website
    };

    try {
      const { success } = await PUT('/api/v1/1/merchants/organization_info_app', data);

      if (success) {
        this.setState({
          isLocked: false
        }, () => {
          setStatus('success');

          this.handleClose();
          this.props.getOrgData();
          this.context.handleGetProfile();
          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'success',
            systemDialogTitle: 'Great!',
            systemDialogContent: 'Successfully saved'
          });
        });
      }
    } catch (error) {
      this.setState({
        isLocked: false
      }, () => {
        this.context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: <GetErrorValidation data={error.data} />
        });

        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, timeerOffModal * 2);
      });
    }
  }


  render(): React.Element {
    const { isOpen } = this.props;
    const {
      companyName,
      supportEmail,
      website,
      billRemark,
      code_501_c3,
      taxLabel,
      openedCropModal,
      baseImage,
      croppedImage,
      imgUrl,
      logo_crop_info
    } = this.state;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
        ignoreOutsideClick
      >
        <div
          className="modal-dialog customModal EditLanguageModal EditOrgModal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Organization Information</h4>
            </div>
            <div className="modal-body EditOrgModalBody">
              <div>
                <div className="form-group">
                  <label htmlFor="companyName">Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id='companyName'
                    value={companyName}
                    onChange={this.handleChangeInput}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="supportEmail">Default customer support email</label>
                  <input
                    type="email"
                    className="form-control"
                    id='supportEmail'
                    value={supportEmail}
                    onChange={this.handleChangeInput}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="supportEmail">Company website URL</label>
                  <div className="input-group">
                    <span className="input-group-addon" id="basic-addon2">www.</span>
                    <input
                      type="text"
                      className="form-control"
                      id='website'
                      value={website}
                      onChange={this.handleChangeInput}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="supportEmail">Bill statement descriptor</label>
                  <input
                    type="text"
                    className="form-control"
                    id='billRemark'
                    value={billRemark}
                    onChange={this.handleChangeInput}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="supportEmail">Tax number</label>
                  <input
                    type="text"
                    className="form-control"
                    id='code_501_c3'
                    value={code_501_c3}
                    onChange={this.handleChangeInput}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="supportEmail">Tax label</label>
                  <input
                    type="text"
                    className="form-control"
                    id='taxLabel'
                    value={taxLabel}
                    onChange={this.handleChangeInput}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="supportEmail">Company logo</label>
                  <DropCropeZone
                    openedCropModal={openedCropModal}
                    baseImage={baseImage}
                    croppedImage={croppedImage}
                    setOpenedCropModal={this.setOpenedCropModal}
                    setBaseImage={this.setBaseImage}
                    setCroppedImage={this.setCroppedImage}
                    id='orgLogo'
                    // eslint-disable-next-line
                    handleSetImages={this.handleSetImages}
                    // eslint-disable-next-line
                    setImageCropInfo={this.handleImageCropInfo}
                    image_crop_info={logo_crop_info}
                    imgUrl={imgUrl}
                    aspect={1}
                  />
                </div>
                {baseImage.image ? (
                <div
                  className="form-group form-group--adjust"
                  style={{
                    marginTop: '1rem'
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-default-blue"
                    onClick={() => {
                      this.setOpenedCropModal(true);
                    }}
                  >
                    <i
                      className="icon icon-crop"
                      style={{ marginRight: '1rem' }}
                    />
                    <span>
                      Adjust
                    </span>
                  </button>
                </div>
              ) : null}
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Close</button>

              <span className="custom-pb-container">
                <BtnLoader
                  label='Save'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    this.handleSave(setStatus);
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EditOrgModal;
